import React from "react"
import PropTypes from "prop-types"
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
} from "@mui/material"
import CloseBud from "assets/images/budgeting/CloseBud.png"
import i18n from "i18n"

const ModalConfirm = ({ open, setOpen }) => {
  return (
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="xs" fullWidth>
      <DialogContent>
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
          <img src={CloseBud} alt="close" style={{ width: 64, height: 64 }} />
        </Box>
        <Box
          sx={{
            mt: 3,
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Box
            component="span"
            sx={{ fontSize: 18, textAlign: "center", fontWeight: 500 }}
          >
            {i18n.t("profile.passworldChanged")}
          </Box>
        </Box>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
        <Button
          variant="contained"
          color="branded"
          size="large"
          onClick={() => setOpen(false)}
        >
          {i18n.t("profile.close")}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

ModalConfirm.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
}

export default ModalConfirm
